module.exports = __webpack_public_path__ + "static/media/grains_1.f7442672.png";